//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const value = ref(0)
    const fruits = ref(0)
    const ticksLabels = ['Figs', 'Lemon', 'Pear', 'Apple']

    return { value, fruits, ticksLabels }
  },
}
